import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Users, Target, CalendarDays, Crown } from "lucide-react";

const STATS = [
  { value: "10K+", label: "Active Fans" },
  { value: "15K+", label: "Daily Posts" },
  { value: "10+", label: "Sports" },
  { value: "2025", label: "Founded" },
];

export default function AboutModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#0E1117] border border-white/10 text-white max-w-2xl rounded-2xl max-h-[85vh] overflow-y-auto p-0">
        <DialogDescription className="sr-only">About Fanible</DialogDescription>

        {/* Header banner */}
        <div className="relative px-8 pt-10 pb-8 border-b border-white/8"
          style={{ background: "linear-gradient(135deg, #0A0D1F 0%, #0E1117 60%)" }}>
          <div className="absolute inset-0 opacity-[0.03]"
            style={{ backgroundImage: "linear-gradient(#3B9EFF 1px, transparent 1px), linear-gradient(90deg, #3B9EFF 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
          <DialogHeader className="relative">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-6 h-px bg-[#3B9EFF]" />
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#3B9EFF] font-outfit">Our Story</span>
            </div>
            <DialogTitle className="font-outfit font-black text-3xl sm:text-4xl tracking-tight text-white text-left">
              About <span className="text-[#3B9EFF]">Fanible</span>
            </DialogTitle>
          </DialogHeader>
        </div>

        <div className="px-8 py-8 space-y-8">

          {/* About text */}
          <div>
            <p className="text-[#C4C4C4] text-sm leading-relaxed font-inter">
              Welcome to <span className="text-white font-semibold">Fanible</span> – the ultimate destination for sports enthusiasts in India! Whether you're a die-hard cricket fan, a football aficionado, a basketball lover, or passionate about any other sport, Fanible brings you all together in one place.
            </p>
            <p className="text-[#C4C4C4] text-sm leading-relaxed font-inter mt-3">
              Our mission is simple: to create a dynamic community where fans from all walks of life can connect, share, and celebrate their love for sports.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-4 gap-3">
            {STATS.map(({ value, label }) => (
              <div key={label} className="bg-[#191D27] border border-white/6 rounded-xl p-4 text-center">
                <div className="font-outfit font-black text-xl text-[#3B9EFF]">{value}</div>
                <div className="text-[#A1A1AA] text-[10px] mt-0.5 uppercase tracking-wider">{label}</div>
              </div>
            ))}
          </div>

          {/* Our Goal */}
          <div className="bg-[#191D27] border border-white/6 rounded-2xl p-6">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-xl bg-[#3B9EFF]/10 flex items-center justify-center flex-shrink-0">
                <Target size={16} className="text-[#3B9EFF]" />
              </div>
              <h3 className="font-outfit font-bold text-white text-base">Our Goal</h3>
            </div>
            <p className="text-[#C4C4C4] text-sm leading-relaxed font-inter">
              To become India's most loved sports social platform — a space where every fan, regardless of their favourite sport or team, feels seen, heard, and connected. We are building the future of sports fandom, powered by community, creativity, and passion.
            </p>
          </div>

          {/* Key Info */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-[#191D27] border border-white/6 rounded-xl p-5 flex items-start gap-3">
              <div className="w-8 h-8 rounded-xl bg-[#3B9EFF]/10 flex items-center justify-center flex-shrink-0">
                <Crown size={15} className="text-[#3B9EFF]" />
              </div>
              <div>
                <p className="text-[10px] text-[#A1A1AA] uppercase tracking-wider mb-1">Founder & CEO</p>
                <p className="text-white font-semibold text-sm">Dinkar</p>
                <p className="text-[#A1A1AA] text-xs mt-0.5 leading-relaxed">Visionary founder who built Fanible to unite sports fans across India.</p>
              </div>
            </div>
            <div className="bg-[#191D27] border border-white/6 rounded-xl p-5 flex items-start gap-3">
              <div className="w-8 h-8 rounded-xl bg-[#3B9EFF]/10 flex items-center justify-center flex-shrink-0">
                <CalendarDays size={15} className="text-[#3B9EFF]" />
              </div>
              <div>
                <p className="text-[10px] text-[#A1A1AA] uppercase tracking-wider mb-1">Founded</p>
                <p className="text-white font-semibold text-sm">7th July, 2025</p>
                <p className="text-[#A1A1AA] text-xs mt-0.5 leading-relaxed">Born with a mission to connect India's 1.4 billion sports fans.</p>
              </div>
            </div>
          </div>

          {/* Communities */}
          <div>
            <p className="text-[10px] text-[#A1A1AA] uppercase tracking-wider mb-3 font-bold">Sports We Cover</p>
            <div className="flex flex-wrap gap-2">
              {["Cricket", "Football", "Basketball", "Tennis", "Kabaddi", "Hockey", "Badminton", "Esports", "& More"].map((sport) => (
                <span key={sport} className="text-xs font-medium px-3 py-1.5 rounded-full bg-[#3B9EFF]/10 text-[#3B9EFF] border border-[#3B9EFF]/20">
                  {sport}
                </span>
              ))}
            </div>
          </div>

        </div>
      </DialogContent>
    </Dialog>
  );
}
